let ws = null
let reconnectTimer = null
let heartbeatTimer = null
let reconnectAttempts = 0

const MAX_RECONNECT_DELAY = 15000

const getWsUrl = () => {
  const proto = window.location.protocol === 'https:' ? 'wss' : 'ws'
  const host = window.location.hostname
  // 生产环境不带端口，走 Nginx 默认的 80/443
  return `${proto}://${host}/ws/user`
}

const safeJsonParse = (s) => {
  try {
    return JSON.parse(s)
  } catch (e) {
    return null
  }
}

const clearTimers = () => {
  if (reconnectTimer) {
    clearTimeout(reconnectTimer)
    reconnectTimer = null
  }
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer)
    heartbeatTimer = null
  }
}

const startHeartbeat = () => {
  if (heartbeatTimer) clearInterval(heartbeatTimer)
  heartbeatTimer = setInterval(() => {
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify({ type: 'ping' }))
    }
  }, 25000)
}

const scheduleReconnect = (connectFn) => {
  if (reconnectTimer) return
  reconnectAttempts += 1
  const delay = Math.min(MAX_RECONNECT_DELAY, 800 + reconnectAttempts * 600)
  reconnectTimer = setTimeout(() => {
    reconnectTimer = null
    connectFn()
  }, delay)
}

export const connectUserWs = ({
  getToken,
  onKick,
  onMessage,
  onAuthed
} = {}) => {
  const tokenGetter = typeof getToken === 'function' ? getToken : () => localStorage.getItem('user_token')

  const connect = () => {
    const token = tokenGetter()
    if (!token) {
      disconnectUserWs()
      return
    }

    try {
      if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) {
        return
      }

      ws = new WebSocket(getWsUrl())

      ws.onopen = () => {
        reconnectAttempts = 0
        startHeartbeat()
        ws.send(JSON.stringify({ type: 'auth', token }))
      }

      ws.onmessage = (ev) => {
        const msg = safeJsonParse(ev.data)
        if (!msg || !msg.type) return

        if (msg.type === 'kick') {
          if (typeof onKick === 'function') onKick(msg)
          return
        }
        if (msg.type === 'authed') {
          if (typeof onAuthed === 'function') onAuthed(msg)
          return
        }
        if (typeof onMessage === 'function') onMessage(msg)
      }

      ws.onclose = () => {
        clearTimers()
        scheduleReconnect(connect)
      }

      ws.onerror = () => {
        // onclose 会触发重连
      }
    } catch (e) {
      scheduleReconnect(connect)
    }
  }

  connect()

  return {
    reconnect: connect
  }
}

export const disconnectUserWs = () => {
  clearTimers()
  reconnectAttempts = 0
  if (ws) {
    try {
      ws.close()
    } catch (e) {
      // ignore
    }
  }
  ws = null
}

